"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchBar;

var _react = _interopRequireWildcard(require("react"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _core = require("@material-ui/core");

var _Input = _interopRequireDefault(require("../Input/Input"));

var _SearchBar = require("./SearchBar.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function SearchBar(_ref) {
  var onSearch = _ref.onSearch,
      keyMap = _ref.keyMap,
      placeholder = _ref.placeholder,
      clearSearch = _ref.clearSearch,
      _ref$backgroundcolor = _ref.backgroundcolor,
      backgroundcolor = _ref$backgroundcolor === void 0 ? "#ffffff" : _ref$backgroundcolor,
      _ref$chipBackgroundCo = _ref.chipBackgroundColor,
      chipBackgroundColor = _ref$chipBackgroundCo === void 0 ? "#e3f2fd" : _ref$chipBackgroundCo,
      _ref$chipColor = _ref.chipColor,
      chipColor = _ref$chipColor === void 0 ? "#1976d2" : _ref$chipColor,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 1 : _ref$elevation,
      clearable = _ref.clearable,
      _ref$defaultKey = _ref.defaultKey,
      defaultKey = _ref$defaultKey === void 0 ? null : _ref$defaultKey,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? [] : _ref$defaultValue,
      focused = _ref.focused,
      setFocused = _ref.setFocused;

  var _useState = (0, _react.useState)(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultKey),
      _useState4 = _slicedToArray(_useState3, 2),
      keySelected = _useState4[0],
      setKeySelected = _useState4[1];

  var resetSearch = function resetSearch() {
    clearSearch();
    setSearch([]);
  };

  (0, _react.useEffect)(function () {
    if (focused !== undefined) {
      focused && input.current.focus();
    }
  }, [focused]);
  (0, _react.useEffect)(function () {
    if (defaultKey && defaultValue) {
      setKeySelected(null);

      var _search = _toConsumableArray(search);

      var last = _search.pop();

      _search = [].concat(_toConsumableArray(_search), [{
        key: last.key,
        value: defaultValue[0].value
      }]);
      setSearch(_search);
    } // eslint-disable-next-line

  }, []);
  var input = (0, _react.useRef)(null);

  var selectKey = function selectKey(value) {
    if (keySelected) {
      setKeySelected(null);

      var _search = _toConsumableArray(search);

      var last = _search.pop();

      _search = [].concat(_toConsumableArray(_search), [{
        key: last.key,
        value: value
      }]);
      setSearch(_search);
      onSearch(_search.reduce(function (acc, _ref2) {
        var key = _ref2.key,
            value = _ref2.value;
        acc[key] = value;
        return acc;
      }, {}));
    } else {
      setKeySelected(value);
      setSearch([].concat(_toConsumableArray(search), [{
        key: value
      }]));
    }

    if (input.current) {
      input.current.blur();
      requestAnimationFrame(function () {
        return input.current && input.current.focus();
      });
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    var backspace = {
      keyCode: 8
    };

    if (event.keyCode === backspace.keyCode && event.target.value === "") {
      if (keySelected === null) {
        var _search = search.slice(0, -1);

        setSearch(_search);
      } else {
        setKeySelected(null);
      }
    }
  };

  var handleInputChange = function handleInputChange(_, value) {
    if (keyMap[value] || keySelected && keyMap[keySelected].includes(value)) {
      selectKey(value);
    }
  };

  var handleChange = function handleChange(_, _ref3, reason) {
    var _ref4 = _slicedToArray(_ref3, 1),
        value = _ref4[0];

    if (reason !== "select-option") return;
    selectKey(value);
  };

  var handleRemoveKey = function handleRemoveKey(key, value, search) {
    if (key === "Tag") {
      return search.filter(function (i) {
        return i.value !== value;
      });
    } else return search.filter(function (i) {
      return i.key !== key;
    });
  };

  var handleRemove = function handleRemove(key, value) {
    return function () {
      var _search = handleRemoveKey(key, value, search);

      setSearch(_search);

      if (keySelected) {
        setKeySelected(null);
      } else {
        onSearch(_search.reduce(function (acc, _ref5) {
          var key = _ref5.key,
              value = _ref5.value;
          acc[key] = value;
          return acc;
        }, {}), true);
      }
    };
  };

  var handleTagsKeyMap = function handleTagsKeyMap() {
    var keyMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var selectedTagValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (Object.keys(keyMap).includes("Tag")) {
      return _objectSpread({}, keyMap, {
        Tag: keyMap.Tag.filter(function (tag) {
          return !selectedTagValues.includes(tag);
        })
      });
    } else return keyMap;
  };

  var getOptions = function getOptions() {
    var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var selected = search.filter(function (item) {
      return (item || {}).key !== "Tag";
    }).reduce(function (acc, i) {
      acc[i.key] = true;
      return acc;
    }, {}); // eslint-disable-next-line array-callback-return

    var selectedTagValues = search.map(function (item) {
      return item.key === "Tag" ? item.value : "";
    }).filter(Boolean);

    if (search.length > 0 && !search[search.length - 1].value) {
      var modifiedKeyMap = handleTagsKeyMap(keyMap, selectedTagValues);

      var options = _toConsumableArray(new Set(modifiedKeyMap[search[search.length - 1].key].reduce(function (a, v) {
        return a.concat(typeof v === "number" ? String(v) : v);
      }, []).filter(function (item) {
        return typeof item === "string" && !selectedTagValues.includes(item) && item.trim() !== "" || Array.isArray(item);
      }))).sort();

      return options;
    }

    return Object.keys(keyMap).filter(function (k) {
      return !selected[k];
    });
  };

  var checkForChip = function checkForChip() {
    return search.find(function (item) {
      return item.value !== undefined;
    }) && keySelected === null;
  };

  var handleBlur = function handleBlur() {
    return focused !== undefined && setFocused(false);
  };

  return /*#__PURE__*/_react.default.createElement(_SearchBar.SearchView, null, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: "search-wrapper",
    elevation: elevation,
    backgroundcolor: backgroundcolor,
    chipBackgroundColor: chipBackgroundColor,
    chipColor: chipColor
  }, /*#__PURE__*/_react.default.createElement(_Search.default, {
    className: "search-icon"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "chip-wrapper"
  }, search.map(function (_ref6) {
    var key = _ref6.key,
        value = _ref6.value;

    if (!value) {
      return "".concat(key, ":");
    }

    return /*#__PURE__*/_react.default.createElement(_core.Chip, {
      className: "chip",
      key: "".concat(key, "-").concat(value),
      size: "small",
      label: value ? "".concat(key, ": ").concat(value) : key,
      onDelete: handleRemove(key, value)
    });
  })), /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
    className: "autocomplete",
    value: [],
    onInputChange: handleInputChange,
    onKeyDown: handleKeyDown,
    multiple: true,
    options: getOptions(search),
    onChange: handleChange,
    onBlur: handleBlur,
    openOnFocus: true,
    id: "1",
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: params.InputProps.ref
      }, /*#__PURE__*/_react.default.createElement(_Input.default, {
        ref: input,
        placeholder: placeholder,
        inputClassName: "search-input",
        className: "mui-input-wrapper",
        inputProps: params.inputProps,
        background: "transparent",
        id: "1",
        variant: "naked"
      }));
    }
  }), checkForChip() && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: resetSearch
  }, /*#__PURE__*/_react.default.createElement(_Clear.default, null))));
}

//# sourceMappingURL=SearchBar.js.map